import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  // apiKey: "AIzaSyAzTg15y57Chg4trEihD68X2QAMBWV7GFQ",
  // authDomain: "event-nest-9b8d9.firebaseapp.com",
  // projectId: "event-nest-9b8d9",
  // storageBucket: "event-nest-9b8d9.appspot.com", // <-- fix: should be .appspot.com
  // messagingSenderId: "848271603043",
  // appId: "1:848271603043:web:712d55c2f6ddab2d564f56"

  apiKey: "AIzaSyA_rcHk3S6udodB7FhrspzZG9iAJzBZjzo",
  authDomain: "eventnest-30316.firebaseapp.com",
  projectId: "eventnest-30316",
  storageBucket: "eventnest-30316.firebasestorage.app",
  messagingSenderId: "284773515596",
  appId: "1:284773515596:web:16d31204805714d28d0fe9",
  measurementId: "G-XZ98S5DE1S"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);